<template>
    <div
        :class="[
            buttonClasses,
            'group flex items-center p-1.5 rounded-full border transition-colors duration-button-hover',
        ]"
        @mouseenter="isHovered = true"
        @mouseleave="isHovered = false"
    >
        <p
            ref="textElement"
            :style="{
                width: showAsExpanded || isHovered ? `${textWidth}px` : '0px',
            }"
            :class="[
                { 'transition-all duration-button-hover': !showAsExpanded },
                'whitespace-nowrap overflow-hidden break-keep text-center',
                textClasses,
            ]"
            v-text="text"
        />

        <component
            :is="icon"
            :class="['transition-colors duration-button-hover', iconSize]"
            :weight="iconWeight"
        />
    </div>
</template>

<script>
import { Link } from '@inertiajs/vue3'

export default {
    components: {
        Link,
    },

    props: {
        modelClass: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            required: true,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
        invertedColors: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: Object,
            default: null,
        },
        iconSize: {
            type: String,
            default: 'size-10',
        },
        iconWeight: {
            type: String,
            default: 'bold',
        },
        textClasses: {
            type: String,
            default: 'text-xl font-medium',
        },
    },

    computed: {
        /**
         * The button should be expanded if the user is on a touch device
         */
        showAsExpanded() {
            return (
                this.expanded ||
                'ontouchstart' in window ||
                navigator.maxTouchPoints > 0 ||
                navigator.msMaxTouchPoints > 0
            )
        },

        buttonClasses() {
            if (this.invertedColors) {
                return [
                    `bg-${this.modelClass}-accent text-${this.modelClass}`,
                    this.showAsExpanded
                        ? `hover:scale-105 transition-transform duration-button-hover`
                        : '',
                ]
            }
            return [
                `text-${this.modelClass}-accent`,
                this.showAsExpanded
                    ? `border-${this.modelClass}-accent hover:bg-${this.modelClass}-accent hover:text-${this.modelClass}`
                    : `border-transparent hover:border-${this.modelClass}-accent`,
            ]
        },
    },

    data() {
        return {
            textWidth: 0,
            isHovered: false,
        }
    },

    mounted() {
        this.calculateTextWidth()
    },

    watch: {
        text() {
            this.calculateTextWidth()
        },
    },

    methods: {
        calculateTextWidth() {
            // Create a temporary span to measure text width
            const span = document.createElement('span')
            span.style.visibility = 'hidden'
            span.style.position = 'absolute'
            span.style.whiteSpace = 'nowrap'
            // Copy the text styles from the actual element
            const styles = window.getComputedStyle(this.$refs.textElement)
            span.style.fontSize = styles.fontSize
            span.style.fontFamily = styles.fontFamily
            span.style.fontWeight = styles.fontWeight
            span.textContent = this.text

            document.body.appendChild(span)
            this.textWidth = span.offsetWidth + 15
            document.body.removeChild(span)
        },
    },
}
</script>
